import type { DifficultyLevel, QuestionType } from './questionTypes';

export type QuestionOptionValue = string | number | boolean | null;

export type QuestionOptionPayload = Record<string, QuestionOptionValue>;

export const TTS_OPTIONS_KEY = 'tts' as const;
export type OptionsKey = QuestionType | typeof TTS_OPTIONS_KEY;

export interface QuestionOptionsStateRecord {
  options: Partial<Record<OptionsKey, QuestionOptionPayload>>;
  manualPlacements: Record<string, ManualPlacementEntry>;
  updatedAt: string;
  version: number;
}

export interface ManualPlacementEntry {
  key: string;
  passageId: string;
  questionType: QuestionType;
  difficulty: DifficultyLevel;
  text: string;
  mode: 'general' | 'mocktest';
  updatedAt: string;
  createdAt?: string;
  authorId?: string;
}

export interface QuestionOptionsContextValue {
  isLoading: boolean;
  error: Error | null;
  options: Partial<Record<OptionsKey, QuestionOptionPayload>>;
  manualPlacements: Record<string, ManualPlacementEntry>;
  getOption: (type: OptionsKey) => QuestionOptionPayload | undefined;
  setOption: (type: OptionsKey, payload: QuestionOptionPayload) => void;
  mergeOption: (
    type: OptionsKey,
    patch: QuestionOptionPayload
  ) => QuestionOptionPayload;
  clearOption: (type: OptionsKey) => void;
  setManualPlacement: (entry: ManualPlacementEntry) => void;
  removeManualPlacement: (key: string) => void;
  getManualPlacementKey: (
    passageId: string,
    questionType: QuestionType,
    difficulty: DifficultyLevel
  ) => string;
  resetAllOptions: (type?: OptionsKey) => void;
  refresh: () => Promise<void>;
}

export const QUESTION_OPTIONS_STORAGE_VERSION = 1;
export const QUESTION_OPTIONS_STORAGE_KEY =
  'autoqm-question-options-state-v1';

export const createManualPlacementKey = (
  passageId: string,
  questionType: QuestionType,
  difficulty: DifficultyLevel
): string => `${passageId} // ${questionType}_${difficulty}`;
